import { render, staticRenderFns } from "./EditSubjectStatusDialog.vue?vue&type=template&id=57bbdde0&scoped=true"
import script from "@/views/Schedules/EditSubjectStatusDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Schedules/EditSubjectStatusDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Schedules/edit-subject-status-dialog.scss?vue&type=style&index=0&id=57bbdde0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bbdde0",
  null
  
)

export default component.exports